"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParticipantSearch = exports.ParticipantList = exports.ParticipantCount = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _reactWindow = require("react-window");
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _RoleChangeModal = require("../RoleChangeModal");
var _ConnectionIndicator = require("../Connection/ConnectionIndicator");
var _ParticipantFilter = require("./ParticipantFilter");
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _useSidepane = require("../AppData/useSidepane");
var _utils = require("../../common/utils");
var _constants = require("../../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ParticipantList = function ParticipantList() {
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    filter = _useState2[0],
    setFilter = _useState2[1];
  var _useParticipants = (0, _reactSdk.useParticipants)(filter),
    participants = _useParticipants.participants,
    isConnected = _useParticipants.isConnected,
    peerCount = _useParticipants.peerCount,
    rolesWithParticipants = _useParticipants.rolesWithParticipants;
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedPeerId = _useState4[0],
    setSelectedPeerId = _useState4[1];
  var toggleSidepane = (0, _useSidepane.useSidepaneToggle)(_constants.SIDE_PANE_OPTIONS.PARTICIPANTS);
  var onSearch = (0, _react.useCallback)(function (value) {
    setFilter(function (filterValue) {
      if (!filterValue) {
        filterValue = {};
      }
      filterValue.search = value;
      return _objectSpread({}, filterValue);
    });
  }, []);
  if (peerCount === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      direction: "column",
      css: {
        size: "100%"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        align: "center",
        css: {
          w: "100%",
          mb: "$10"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          css: {
            fontWeight: "$semiBold",
            mr: "$4"
          },
          children: "Participants"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ParticipantFilter.ParticipantFilter, {
          selection: filter,
          onSelection: setFilter,
          isConnected: isConnected,
          roles: rolesWithParticipants
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
          onClick: toggleSidepane,
          css: {
            w: "$11",
            h: "$11",
            ml: "auto"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CrossIcon, {})
        })]
      }), !(filter !== null && filter !== void 0 && filter.search) && participants.length === 0 ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(ParticipantSearch, {
        onSearch: onSearch
      }), participants.length === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
        align: "center",
        justify: "center",
        css: {
          w: "100%",
          p: "$8 0"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          children: !filter ? "No participants" : "No matching participants"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(VirtualizedParticipants, {
        participants: participants,
        isConnected: isConnected,
        setSelectedPeerId: setSelectedPeerId
      })]
    }), selectedPeerId && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RoleChangeModal.RoleChangeModal, {
      peerId: selectedPeerId,
      onOpenChange: function onOpenChange(value) {
        !value && setSelectedPeerId(null);
      }
    })]
  });
};
exports.ParticipantList = ParticipantList;
var ParticipantCount = function ParticipantCount() {
  var peerCount = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeerCount);
  var toggleSidepane = (0, _useSidepane.useSidepaneToggle)(_constants.SIDE_PANE_OPTIONS.PARTICIPANTS);
  var isParticipantsOpen = (0, _useSidepane.useIsSidepaneTypeOpen)(_constants.SIDE_PANE_OPTIONS.PARTICIPANTS);
  (0, _react.useEffect)(function () {
    if (isParticipantsOpen && peerCount === 0) {
      toggleSidepane();
    }
  }, [isParticipantsOpen, peerCount, toggleSidepane]);
  if (peerCount === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_IconButton["default"], {
    css: {
      w: "auto",
      p: "$4",
      h: "auto"
    },
    onClick: function onClick() {
      if (peerCount > 0) {
        toggleSidepane();
      }
    },
    active: !isParticipantsOpen,
    "data-testid": "participant_list",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PeopleIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "sm",
      css: {
        mx: "$4",
        c: "inherit"
      },
      children: peerCount
    })]
  });
};
exports.ParticipantCount = ParticipantCount;
var VirtualizedParticipants = function VirtualizedParticipants(_ref) {
  var participants = _ref.participants,
    canChangeRole = _ref.canChangeRole,
    isConnected = _ref.isConnected,
    setSelectedPeerId = _ref.setSelectedPeerId;
  var _useMeasure = (0, _reactUse.useMeasure)(),
    _useMeasure2 = _slicedToArray(_useMeasure, 2),
    ref = _useMeasure2[0],
    _useMeasure2$ = _useMeasure2[1],
    width = _useMeasure2$.width,
    height = _useMeasure2$.height;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
    ref: ref,
    css: {
      flex: "1 1 0",
      mr: "-$10"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactWindow.FixedSizeList, {
      itemSize: 68,
      itemCount: participants.length,
      width: width,
      height: height,
      children: function children(_ref2) {
        var index = _ref2.index,
          style = _ref2.style;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: style,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Participant, {
            peer: participants[index],
            canChangeRole: canChangeRole,
            showActions: isConnected,
            onParticipantAction: setSelectedPeerId
          })
        }, participants[index].id);
      }
    })
  });
};
var Participant = function Participant(_ref3) {
  var peer = _ref3.peer,
    canChangeRole = _ref3.canChangeRole,
    showActions = _ref3.showActions,
    onParticipantAction = _ref3.onParticipantAction;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: {
      w: "100%",
      py: "$4",
      pr: "$10"
    },
    align: "center",
    "data-testid": "participant_" + peer.name,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Avatar, {
      name: peer.name,
      css: {
        position: "unset",
        transform: "unset",
        mr: "$8",
        fontSize: "$sm",
        size: "$12",
        p: "$4"
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      direction: "column",
      css: {
        flex: "1 1 0"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "md",
        css: _objectSpread(_objectSpread({}, (0, _reactUi.textEllipsis)(150)), {}, {
          fontWeight: "$semiBold"
        }),
        children: peer.name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "sub2",
        children: peer.roleName
      })]
    }), showActions && /*#__PURE__*/(0, _jsxRuntime.jsx)(ParticipantActions, {
      peerId: peer.id,
      role: peer.roleName,
      onSettings: function onSettings() {
        onParticipantAction(peer.id);
      },
      canChangeRole: canChangeRole
    })]
  }, peer.id);
};

/**
 * shows settings to change for a participant like changing their role
 */
var ParticipantActions = /*#__PURE__*/_react["default"].memo(function (_ref4) {
  var _useHMSStore, _useHMSStore2;
  var onSettings = _ref4.onSettings,
    peerId = _ref4.peerId,
    role = _ref4.role;
  var isHandRaised = (_useHMSStore = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectPeerMetadata)(peerId))) === null || _useHMSStore === void 0 ? void 0 : _useHMSStore.isHandRaised;
  var canChangeRole = (_useHMSStore2 = (0, _reactSdk.useHMSStore)(_reactSdk.selectPermissions)) === null || _useHMSStore2 === void 0 ? void 0 : _useHMSStore2.changeRole;
  var audioTrack = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAudioTrackByPeerID)(peerId));
  var localPeerId = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerID);
  var canChangeVolume = peerId !== localPeerId && audioTrack;
  var shouldShowMoreActions = canChangeRole || canChangeVolume;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    align: "center",
    css: {
      flexShrink: 0
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ConnectionIndicator.ConnectionIndicator, {
      peerId: peerId
    }), isHandRaised && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.HandRaiseIcon, {}), shouldShowMoreActions && !(0, _utils.isInternalRole)(role) && /*#__PURE__*/(0, _jsxRuntime.jsx)(ParticipantMoreActions, {
      onRoleChange: onSettings,
      peerId: peerId,
      role: role
    })]
  });
});
var ParticipantMoreActions = function ParticipantMoreActions(_ref5) {
  var _useHMSStore3;
  var onRoleChange = _ref5.onRoleChange,
    peerId = _ref5.peerId;
  var canChangeRole = (_useHMSStore3 = (0, _reactSdk.useHMSStore)(_reactSdk.selectPermissions)) === null || _useHMSStore3 === void 0 ? void 0 : _useHMSStore3.changeRole;
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Root, {
    open: open,
    onOpenChange: function onOpenChange(value) {
      return setOpen(value);
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Trigger, {
      asChild: true,
      "data-testid": "participant_more_actions",
      css: {
        p: "$2",
        r: "$0"
      },
      tabIndex: 0,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.VerticalMenuIcon, {})
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Content, {
        align: "end",
        sideOffset: 8,
        css: {
          w: "$64"
        },
        children: [canChangeRole && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
          onClick: function onClick() {
            return onRoleChange(peerId);
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChangeRoleIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            css: {
              ml: "$4"
            },
            children: "Change Role"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ParticipantVolume, {
          peerId: peerId
        })]
      })
    })]
  });
};
var ParticipantVolume = function ParticipantVolume(_ref6) {
  var peerId = _ref6.peerId;
  var audioTrack = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAudioTrackByPeerID)(peerId));
  var localPeerId = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerID);
  var hmsActions = (0, _reactSdk.useHMSActions)();
  // No volume control for local peer or non audio publishing role
  if (peerId === localPeerId || !audioTrack) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Item, {
    css: {
      h: "auto"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      direction: "column",
      css: {
        w: "100%"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        align: "center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.SpeakerIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
          css: {
            ml: "$4"
          },
          children: ["Volume", audioTrack.volume ? "(".concat(audioTrack.volume, ")") : ""]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Slider, {
        css: {
          my: "0.5rem"
        },
        step: 5,
        value: [audioTrack.volume],
        onValueChange: function onValueChange(e) {
          hmsActions.setVolume(e[0], audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.id);
        }
      })]
    })
  });
};
var ParticipantSearch = function ParticipantSearch(_ref7) {
  var onSearch = _ref7.onSearch,
    placeholder = _ref7.placeholder;
  var _React$useState = _react["default"].useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  (0, _reactUse.useDebounce)(function () {
    onSearch(value);
  }, 300, [value, onSearch]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    css: {
      p: "$4 0",
      my: "$8",
      position: "relative"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        position: "absolute",
        left: "$4",
        top: "$2",
        transform: "translateY(50%)",
        color: "$textMedEmp"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.SearchIcon, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Input, {
      type: "text",
      placeholder: placeholder || "Find what you are looking for",
      css: {
        w: "100%",
        pl: "$14"
      },
      value: value,
      onKeyDown: function onKeyDown(event) {
        event.stopPropagation();
      },
      onChange: function onChange(event) {
        setValue(event.currentTarget.value);
      },
      autoComplete: "off",
      "aria-autocomplete": "none"
    })]
  });
};
exports.ParticipantSearch = ParticipantSearch;